<template>

	<section>
		<container>
			<div class="stats-wrapper">
				<div class="headline">
					<p>StudySync is owned by Imagine Learning. If you would like to contact us please visit us <a href="https://www.imaginelearning.com/about/contact-us/">here</a>.</p>
				</div>
			</div>
		</container>
	</section>

</template>

<script>

	export default {
		name: "AboutIntro"
	}

</script>

<style lang="scss" scoped>
	@import "responsive-font";
	@import "media.scss";
	@import "list-style-reset.scss";

	section {
		padding:5vw 0;
	}

	.stats-wrapper {
		@include media(large) {
			display:flex;
		}
		& > * {
			flex: 1 1 50%;
		}
	}

	.headline {
		flex:1 0 50%;
		@include media(large) {
			margin-right:6vw;
		}
	}

	h3 {
		font-size:3.5rem; line-height:1.25; font-weight:400; color:#3D3D3D; text-transform:uppercase; max-width:37.5rem;
	}

	.stats {
		@include list-style-reset;
		display:flex; flex-wrap:wrap; color:#6D6E71; font-weight:600; flex:1 0 50%;
		@include media(large) {
			margin:-1em -2em;
		}
		li {
			@include responsive-font(16);
			flex:0 0 50%; line-height: 1.3; margin:1em auto;
		}
		mark {
			@include responsive-font(45);
			line-height:1; color:#FDB913; font-family:"oswald"; display:block; margin-bottom:2.3rem; font-weight:400;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/OurCompany/AboutIntro.vue